import React from "react"
import { useEffect } from "react"
// import { Link } from 'gatsby';
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import { withOutScript } from "../../../shared/utils/formatString"
import { pushGtagEvent } from "../../../shared/utils/metricManagementUtil"
import { createListProductPayload } from "../../../shared/utils/payloadDatalayer"
import { datalayerProduct } from "../../../shared/utils/datalayerProducts"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"

import "./you-can-use-product.scss"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"

const YouCanUseProduct = ({ params }) => {
  var products = params.tambienPuedesUsar

  const item_list_name = `${params.titulo} > Tambien puedes usar`.toLocaleLowerCase()
  const userInfoEncrypt= encryptUserInfo()

  const productGaEvent = ({ product }) => {
    const items = createListProductPayload([product], {
      item_list_name,
      item_list_id: "PF_2345",
    })

    pushGtagEvent({
      event: "select_item",
      params: {
        items,
        item_list_name,
        item_list_id: "PF_2345",
        redemption: "No",
        user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
        log_status: userInfoEncrypt.log_status,
      },
    })
  }

  useEffect(() => {
    const items = createListProductPayload(products, {
      item_list_name,
      item_list_id: "PF_2345",
    })

    pushGtagEvent({
      event: "view_item_list",
      params: {
        items,
        item_list_name,
        item_list_id: "PF_2345",
        redemption: "No",
        user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
        log_status: userInfoEncrypt.log_status,
      },
    })
  }, [])

  return (
    <div className="f-YouCanUse-product">
      {products && (
        <div className="f-YouCanUse-product-wrap">
          <TitleTab
            title={
              process.env.LOCALE === "es-PY" ||
              process.env.LOCALE === "es-AR" ||
              process.env.LOCALE === "es-UY"
                ? "También podés usar"
                : "También puedes usar"
            }
            className="f-TitleTab f-TitleTab-pink"
          />

          <div className="f-YouCanUse-product-content">
            {products.map((product, index) => (
              <a
                href={removeDoubleSlash(
                  `/productos/${product.referenciaSubcategoria.referenciaCategoria.slug}/${product.referenciaSubcategoria.slug}/${product.slug}`
                )}
                onClick={() => {
                  datalayerProduct({
                    subCategory: `${withOutScript(product.referenciaSubcategoria.referenciaCategoria.slug)} > ${withOutScript(product.referenciaSubcategoria.slug)}`,
                    label: product.titulo,
                  })
                  productGaEvent({ product })
                }}
                className="f-YouCanUse-product-content-item"
                key={index}
              >
                <img
                  alt={product.imagenDelProducto.description}
                  src={product.imagenDelProducto.file.url}
                />
                <h3>{product.titulo}</h3>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default YouCanUseProduct
